import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of, throwError } from 'rxjs';
import { Form } from '../../domain/form.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  constructor(private api: ApiService) {}

  getTemplates(formId: string): Observable<any[]> {
    console.log('Get Templates')    
    return this.api.get(`/forms/${formId}/templates`);
  }
  getTemplate(formId: string, template: Form): Observable<{ content: Form }> {
    return this.api.get(`/forms/${formId}/templates/${template.sk}`);
  }

  addTemplate(formId: string): Observable<{ content: Form }> {  
    //const error = new HttpErrorResponse({ status: 500, error: "Testing error" });
    //return throwError(() => error)
    console.log('ADDD TEMPLATE SERVICE')
    return this.api.post(`/forms/${formId}/templates`, {});
  }

  editTemplate(formId: string, template: Form): Observable<{ content: Form }> {
    return this.api.put(`/forms/${formId}/templates/${template.sk}`, template);
  }

  deleteTemplate(formId: string, template: Form): Observable<{ content: { form: Form } }> {
    console.log('Delete Template')
    return this.api.delete(`/forms/${formId}/templates/${template.sk}`, template);
  }

}
